import React, { Component } from 'react';
import IconUnsupported from '../../shared/icons/icon-pageUnsupportedBrowser.svg';


class PageUnsupportedBrowser extends Component {
  static getDomId() {
    return 'errorpage_pageUnsuportedBrowser';
  }

  render() {
    return (
      <section className="page-error__wrapper">
        <h1 className="page-error__title">This site is not supported on Internet Explorer.</h1>
        <div className="page-error__content-row">
          <p className="page-error__text">
            {'You can access the Marketplace with '}
            <a href="https://www.google.com/chrome/" target="_blank" rel="noopener noreferrer">
              Google Chrome
            </a>
            {', '}
            <a
              href="https://www.microsoft.com/en-us/windows/microsoft-edge"
              target="_blank"
              rel="noopener noreferrer"
            >
              Microsoft Edge
            </a>
            {', or '}
            <a
              href="https://www.mozilla.org/en-US/firefox/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Mozilla Firefox
            </a>
            {' browsers. '}
            Follow the links for instructions on how to download and install either browser
          </p>
          <div className="page-error__icon-wrap">
            <IconUnsupported />
          </div>
        </div>
      </section>
    );
  }
}

export default PageUnsupportedBrowser;
